import { getToken, setToken, resetLocalStorage } from "@/utils";

const state = () => ({
  operations: [],
  token: getToken(),
  authorization_code: "",
  enable_mfa: false,
  mfa_qrcode: ""
});

const mutations = {
  UPDATE_OPERATIONS(state, payload) {
    state.operations = payload;
  },
  UPDATE_TOKEN(state, payload) {
    state.token = payload;
    setToken(payload);
  },
  RESET(state) {
    state.operations = [];
    state.token = "";
    state.mfa_qrcode = "";
    resetLocalStorage();
  },
  STORE_MFAQRCODE(state, payload) {
    state.mfa_qrcode = payload;
  },
  SET_AUTHORIZATION_CODE(state, payload) {
    state.authorization_code = payload;
  },
  SET_ENABLE_MFA(state, payload) {
    state.enable_mfa = payload;
  }
};

const actions = {
  updateOperations({ commit }, payload) {
    commit("UPDATE_OPERATIONS", payload);
  },
  updateToken({ commit }, payload) {
    commit("UPDATE_TOKEN", payload);
  },
  reset({ commit }) {
    commit("RESET");
  },
  storeMFAQRcode({ commit }, payload) {
    commit("STORE_MFAQRCODE", payload);
  },
  setAuthorizationCode({ commit }, payload) {
    commit("SET_AUTHORIZATION_CODE", payload);
  },
  setEnableMFA({ commit }, payload) {
    commit("SET_ENABLE_MFA", payload);
  }
};

const getters = {
  operations: state => state.operations,
  isLoggedIn: state => Boolean(state.token),
  token: state => state.token,
  mfa_qrcode: state => state.mfa_qrcode,
  authorization_code: state => state.authorization_code,
  enable_mfa: state => state.enable_mfa
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
